<template>
  <div class="calculator-wrapper">
    <transition name="slide-fade">
      <div
        v-show="isOpened"
        class="calculator-wrapper__box"
      >
        <div class="calculator-wrapper__header">
          <h2>Calculadora de exames</h2>
          <button
            class="btn--transparent-with-icon"
            @click="closeCalculator()"
          >
            <svg-loader src="/static/images/icon-close-purple.svg" />
          </button>
        </div>

        <div class="calculator-wrapper__measures-converter">
          <MeasuresConverter />
        </div>

        <!-- Calcules Cards Bellow -->
        <CalcCard :calc-data="indiceAndrogeniosLivres">
          <IndiceAndrogeniosLivres />
        </CalcCard>

        <CalcCard :calc-data="clearanceCreatinina">
          <ClearanceCreatinina />
        </CalcCard>

        <CalcCard :calc-data="indiceIggLiquor">
          <IndiceIggLiquor />
        </CalcCard>

        <CalcCard :calc-data="lactoseAbsorption">
          <LactoseAbsorption />
        </CalcCard>

        <CalcCard :calc-data="estimativaFiltracaoGlomerular">
          <EstimativaRitmoFiltracaoGlomerular />
        </CalcCard>

        <CalcCard :calc-data="superficieCorporal">
          <SuperficieCorporal />
        </CalcCard>

        <CalcCard :calc-data="indiceMassaCorporeaAdultos">
          <IndiceMassaCorporeaAdultos />
        </CalcCard>

        <CalcCard :calc-data="indiceSaturacaoTransferrina">
          <IndiceSaturacaoTransferrina />
        </CalcCard>

        <CalcCard :calc-data="glicemiaMediaEstimadaHemoglobinaGlicada">
          <GlicemiaMediaEstimadaHemoglobinaGlicada />
        </CalcCard>

        <CalcCard :calc-data="capacidadeTotalCombinacaoFerro">
          <CapacidadeTotalCombinacaoFerro />
        </CalcCard>

        <CalcCard :calc-data="riscoCardiovascular">
          <RiscoCardiovascular />
        </CalcCard>


        <CalcCard :calc-data="indiceDeHomaIR">
          <IndiceDeHomaIR />
        </CalcCard>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-show="isOpened"
        class="calculator-wrapper--overlay"
      />
    </transition>
  </div>
</template>
<script>
import CalcCard from './CalcCard.vue'
import ClearanceCreatinina from './Calculations/ClearanceCreatinina.vue'
import LactoseAbsorption from './Calculations/LactoseAbsorption.vue'
import EstimativaRitmoFiltracaoGlomerular from './Calculations/EstimativaRitmoFiltracaoGlomerular.vue'
import SuperficieCorporal from './Calculations/SuperficieCorporal.vue'
import IndiceMassaCorporeaAdultos from './Calculations/IndiceMassaCorporeaAdultos.vue'
import IndiceSaturacaoTransferrina from './Calculations/IndiceSaturacaoTransferrina.vue'
import GlicemiaMediaEstimadaHemoglobinaGlicada from './Calculations/GlicemiaMediaEstimadaHemoglobinaGlicada.vue'
import CapacidadeTotalCombinacaoFerro from './Calculations/CapacidadeTotalCombinacaoFerro.vue'
import RiscoCardiovascular from './Calculations/RiscoCardiovascular.vue'
import IndiceIggLiquor from './Calculations/IndiceIggLiquor.vue'
import IndiceDeHomaIR from './Calculations/IndiceDeHomaIR.vue'
import MeasuresConverter from './MeasuresConverter/MeasuresConverter.vue'
import IndiceAndrogeniosLivres from './Calculations/IndiceAndrogeniosLivres.vue'

export default {
  name: 'CalculatorWrapper',
  components: {
    CalcCard,
    ClearanceCreatinina,
    LactoseAbsorption,
    IndiceAndrogeniosLivres,
    EstimativaRitmoFiltracaoGlomerular,
    SuperficieCorporal,
    IndiceMassaCorporeaAdultos,
    IndiceSaturacaoTransferrina,
    GlicemiaMediaEstimadaHemoglobinaGlicada,
    CapacidadeTotalCombinacaoFerro,
    RiscoCardiovascular,
    IndiceIggLiquor,
    IndiceDeHomaIR,
    MeasuresConverter
  },
  props: {
    isOpened: {
      default: false,
      required: true,
      type: Boolean
    }
  },
  data: () => {
    return {
      clearanceCreatinina: {
        name: 'Clearance de creatinina com urina de 24h'
      },
      lactoseAbsorption: {
        name: 'Teste de absorção da lactose'
      },
      estimativaFiltracaoGlomerular: {
        name: 'Estimativa do Ritmo de Filtração Glomerular – CKD-EPI',
        refText:
          'Levey AS, Stevens LA, Schmid CH, et al. for the CKD-EPI (Chronic Kidney Disease Epidemiology Collaboration). A New Equation to Estimate Glomerular Filtration Rate. Ann Intern Med. 2009 May 5; 150:604-612. PubMed ID: 19414839'
      },
      superficieCorporal: {
        name: 'Superficie Corporal',
        refText:
          'DuBois D, DuBois E.F. "A formula to estimate the approximate surface area if height and weight be known." Arch. Intern. Med. 17:862, 1916'
      },
      indiceMassaCorporeaAdultos: {
        name: 'Índice de Massa Corporal (Adultos)'
      },
      indiceSaturacaoTransferrina: {
        name: 'Índice de saturação da transferrina'
      },
      glicemiaMediaEstimadaHemoglobinaGlicada: {
        name: 'Glicemia média estimada da hemoglobina glicada'
      },
      capacidadeTotalCombinacaoFerro: {
        name: 'Capacidade total de combinação do ferro (TIBFC)'
      },
      riscoCardiovascular: {
        name: 'Risco Cardiovascular'
      },
      indiceIggLiquor: {
        name: 'Índice de IgG - Líquor'
      },
      indiceDeHomaIR: {
        name: 'Índice de homa - IR'
      },
      indiceAndrogeniosLivres:{
        name: 'Índice de androgênios livres'
      }
    }
  },
  methods: {
    closeCalculator() {
      this.$emit('closeCalculator', false)
    }
  }
}
</script>
<style lang="scss">
  .calculator-wrapper {
    &--overlay {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.7);
      z-index: 999 !important;
    }
    &__box {
      width: 400px;
      background: #f2f2f2;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      padding: 40px 32px;
      transition: all 0.3s ease;
      overflow-x: auto;
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1000;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
        color: #7f1a54;
        font-size: 19px;
      }
      .md-icon {
        width: 15px;
        margin-left: 15px;
        cursor: pointer;
      }
    }

    .md-input-container.md-input-invalid {
      .md-error,
      input {
        color: #960012;
      }

      &:after {
        background-color: #960012 !important;
      }
    }

    &__measures-converter {
      margin: 32px 0;
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(500px);
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
